/**
 * OS-1717 — nombres de las capacidades de plataforma y de los roles, para ocultar menús y acciones.
 * Qué rol tiene cada capacidad lo decide el API (`platformMe`); aquí no hay matriz. El backend
 * sigue siendo la fuente de verdad: lo que se oculta también responde 403 si se llama.
 */
export type PlatformPermission =
  | 'platform.tenants.read'
  | 'platform.tenants.create'
  | 'platform.tenants.update'
  | 'platform.tenants.configure'
  | 'platform.tenants.suspend'
  /** OS-1720 — reactivar un tenant cancelado (solo SUPER). */
  | 'platform.tenants.reactivate'
  | 'platform.modules.write'
  | 'platform.billing.read'
  | 'platform.billing.write'
  /** Credenciales y datos fiscales de Factus por tenant (facturación y nómina electrónica). */
  | 'platform.billing.factus.read'
  | 'platform.billing.factus.write'
  | 'platform.users.read'
  | 'platform.users.support'
  | 'platform.audit.read'
  | 'platform.admins.manage'
  | 'platform.reports.read'
  /** OS-968 — parámetros fiscales y plantilla PUC por país. */
  | 'platform.accounting.reference.write';

export type PlatformAdminRole = 'PLATFORM_ADMIN' | 'SUPPORT_ADMIN' | 'SUPPORT_AGENT' | 'COMMERCIAL';

export const PLATFORM_ROLES: readonly PlatformAdminRole[] = [
  'PLATFORM_ADMIN',
  'SUPPORT_ADMIN',
  'SUPPORT_AGENT',
  'COMMERCIAL',
];

/** Nombres comerciales de los roles (OS-1717). */
export const PLATFORM_ROLE_LABELS: Readonly<Record<PlatformAdminRole, string>> = {
  PLATFORM_ADMIN: 'Super',
  SUPPORT_ADMIN: 'Soporte admin',
  SUPPORT_AGENT: 'Soporte agente',
  COMMERCIAL: 'Comercial',
};

export const PLATFORM_ROLE_DESCRIPTIONS: Readonly<Record<PlatformAdminRole, string>> = {
  PLATFORM_ADMIN: 'Acceso total, incluida la gestión de administradores.',
  SUPPORT_ADMIN: 'Configuración de tenants y soporte a usuarios. Sin facturación ni módulos.',
  SUPPORT_AGENT: 'Consulta de tenants y usuarios para atender tickets. Sin cambios.',
  COMMERCIAL: 'Alta, datos comerciales, estado, módulos y facturación. Sin usuarios ni Help Desk.',
};

export function platformRoleLabel(role: string): string {
  return PLATFORM_ROLE_LABELS[role as PlatformAdminRole] ?? role;
}

/** Código del 403 por capacidad (`PlatformAdminGuard`). */
export const PLATFORM_PERMISSION_DENIED = 'PLATFORM_PERMISSION_DENIED';

/** Clave de react-query de la sesión (`platformMe`). */
export const PLATFORM_SESSION_QUERY_KEY = ['platform-session'] as const;
